import { API_PREFIX, V2_API_PREFIX } from '@constants/urls'

export const API_CITIES_URL = `${V2_API_PREFIX}cities`

export const API_EXCHANGE_RATE_URL = `${API_PREFIX}get-exchange-rate/`
